export const appId = 'org.openedx.frontend.app.ai-studio';
export const aiStudioRole = 'org.openedx.frontend.role.ai-studio';
